// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3Vf86","label":"Section_label__2zcbL","contentWrap":"Section_contentWrap__3vaqW","footer":"Section_footer__2c5xy","footerInner":"Section_footerInner__MLZWW"};